import { render } from "./tncEdit-modal.vue?vue&type=template&id=9573924e"
import script from "./tncEdit-modal.vue?vue&type=script&lang=js"
export * from "./tncEdit-modal.vue?vue&type=script&lang=js"

import "./tncEdit-modal.vue?vue&type=style&index=0&id=9573924e&lang=css"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__